import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { GeneralCandidateCard } from 'features/candidate/components/Candidates/Cards'

export const Grid = ({ items, ...props }) => {
  const { t } = useTranslation()

  return (
    <>
      {items.map((item, i) => (
        <Row key={i}>
          <Col>
            <GeneralCandidateCard
              data={item?.receiver}
              actionBar={false}
              withJobInvite
              jobInvite={item}
              {...props}
            />
          </Col>
        </Row>
      ))}
    </>
  )
}

Grid.propTypes = {
  items: PropTypes.array,
}
